import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';

const STORAGE_KEY = 'lmsInternalLearner';

@Injectable({ providedIn: 'root' })
export class InternalLearnerService {
  private api = inject(ApiService);
  private hasAccessSignal = signal(localStorage.getItem(STORAGE_KEY) === '1');

  readonly hasAccess = this.hasAccessSignal.asReadonly();

  refresh(): Observable<boolean> {
    return this.api.get<{ hasAccess?: boolean }>('lms/collaborateur/access').pipe(
      map((response) => response.hasAccess === true),
      tap((hasAccess) => this.set(hasAccess)),
      catchError(() => {
        this.set(false);
        return of(false);
      })
    );
  }

  set(hasAccess: boolean): void {
    this.hasAccessSignal.set(hasAccess);
    if (hasAccess) {
      localStorage.setItem(STORAGE_KEY, '1');
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  clear(): void {
    this.set(false);
  }
}
